import store from '@/store';

export default (to, from, next) => {
    const is_anonymous_pay_bill_allowed = store.getters.is_app_anonymous_pay_bill_allowed;

    return {
        allow: is_anonymous_pay_bill_allowed,
        redirect: { name: 'not-found' },
    }
};
